import styled, { keyframes } from 'styled-components'

const flipbookAnimation = (length) => keyframes`
  0% {
    left: 0
  }

  to {
    left: -${length - 540}px
  }
`

export const AnimationSliderContainer = styled.div`
  position: relative;
  text-align: center;
  opacity: 1;
  z-index: 1;
  max-width: 80rem;
  margin: 0 auto;

  .slick-prev {
    left: 0;
  }

  .slick-next {
    right: 0;
  }

  .slick-next,
  .slick-prev {
    cursor: pointer;
    top: 35%;
    color: ${props => props.theme.colors.darkGrey};
    width: 2.8rem;
    height: 2.8rem;
    z-index: 5;

    &.slick-disabled {
      color: ${props => props.theme.colors.lightGrey};
    }

    &:hover {
      color: ${props => props.theme.colors.darkGrey};
    }

    &::before {
      content: none;
    }
  }

  .slick-dots {
    position: relative;
    margin-top: -0.3rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      float: none;
      width: 50%;
      margin: 0 auto;
      bottom: 8rem;
    }

    li {
      cursor: pointer;
      display: inline-block;
      width: 4.9rem;
      height: 0.2rem;
      margin-right: 0.2rem;

      &:last-child {
        margin-right: 0;
      }

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        width: 5.4rem;
        margin-right: 0.8rem;
      }

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        width: 5.4rem;
        margin-right: 1.1rem;
      }

      button {
        width: 5.2rem;
        /* To increase clickable area of the position indicators */
        padding: 3rem 0;
        margin: -3rem 0;

        &:before {
          content: '';
          opacity: 1;
          width: 100%;
          border: 1px solid ${props => props.theme.colors.lightGrey};
          height: 1px;
        }

        @media screen and (min-width: ${props => props.theme.responsive.small}) {
          width: 5.4rem;
        }
      }
      &.slick-active {
        button {

          &:before{
            border: 1px solid ${props => props.theme.colors.cobalt};
          }
        }
      }
    }

    button {
      width: 100%;
      height: auto;
      padding: 0;
    }
  }

  .slick-current {
    .animatedImage {
      left: 0;
      opacity: 1;
      animation: ${props => flipbookAnimation(24480)} 2s steps(44) forwards normal;
    }
  }
`

export const LeftArrow = styled.button`
  svg {
    width: 100%;
    height: 100%;
    stroke-width: 4px;
    transform: rotate(180deg);

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      stroke-width: 1px;
    }
  }
`

export const RightArrow = styled.button`
  svg {
    width: 100%;
    height: 100%;
    stroke-width: 4px;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      stroke-width: 1px;
    }
  }
`
